import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_signup/gym/')({
  beforeLoad: () => {
    throw redirect({ to: '/gym/business-details' });
  },
});
